/** For more details on
 * `authContext`, `ProvideAuth`, `useAuth` and `useProvideAuth`
 * refer to: https://usehooks.com/useAuth/
 */
import { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { AuthContext } from '../hooks/useAuth';
import { getTenantProfile } from './providerUtils';

const useProviderAuth = () => {
  const [data, setData] = useState({ loading: true });
  const router = useHistory();

  const getTenantProfileCallback = useCallback(async () => {
    await getTenantProfile(setData, router);
  }, [router]);

  useEffect(() => {
    (async () => getTenantProfile(setData, router))();
  }, [router]);

  return {
    ...data,
    getTenantProfile: getTenantProfileCallback,
  };
};

export function ProviderAuth({ children }) {
  const providerAuth = useProviderAuth();
  return (
    <AuthContext.Provider value={providerAuth}>{children}</AuthContext.Provider>
  );
}

ProviderAuth.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};
